module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAASCAYAAAEVsH/dAAAAAXNSR0IArs4c6QAAAPVJREFUKBWFUDEOgkAQvCMWBAp9gYlPsLK1M4FQ8kYLHmBiRakPsDIxsbWSB8A5s7IXLkDY4m5vbmZubo1BOeesKYpiy4NUlmWPf1eW5Vo6y5WkOI4bQfI8f0kTLJA6I4vC4N20N2KjJ9q1bfteEdAD/DdVVdmIYNd1tbX2DkAeDeR9gA+JQfFDIybAp2dRGuRaBqCNUEf4HPxUAPrB8CdpmjJ841/XX/HCg4zBC/zuHIC8GFavvmAE30li71Ij1I5zSpLkJNNUFyUgnBCQY6/D9GPnlKcIamLVZfiMuiiJu8+4JPBEVc8JRsQpAbDrLFEFyC6cH0pmpTi/CfxDAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/images/arrow-left.png
// module id = 184
// module chunks = 0